// @flow
import React from "react";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import loc from "i18next";
import Button from "react-bootstrap/lib/Button";
import styles from "./Header.module.css";
import { getClassNames } from "data/utils";

type Props = {
    /** optional FontAwesome icon */
    icon?: string,
    /** optional image source */
    image?: string,
    /** header's title to display */
    title?: string,
    /** header's description (as tooltip) */
    description?: string,
    /** whether to render Favorite icon */
    isFav?: boolean,
    /** whether to render Recent icon */
    isRecent?: boolean,
    /** optional center component */
    centerComponent?: React.ElementType,
    /** optional right component */
    rightComponent?: React.ElementType,
    /** callback when user clicks Cancel */
    onCancel?: () => void,
};

/**
 * renders a panel's header
 */
const Header = ({
    icon,
    image,
    title,
    description,
    isFav,
    isRecent,
    centerComponent,
    rightComponent,
    onCancel,
}: Props) => (
    <div
        className={getClassNames(
            styles.wrapper,
            title == null ? "notitle" : ""
        )}
    >
        {icon && <FontAwesome name={icon} size="lg" />}
        {image && <img src={image} alt={title} />}
        {isFav && <FontAwesome name="star-o" size="lg" />}
        {isRecent && <FontAwesome name="history" size="lg" />}
        {title && (
            <span className={styles.title} title={description || title}>
                {title}
            </span>
        )}
        <span className={styles.center}>{centerComponent}</span>
        <span className={styles.right}>{rightComponent}</span>
        {typeof onCancel === "function" && (
            <Button
                aria-label={loc.t("cancel")}
                onClick={onCancel}
                className={styles.cancel}
                bsStyle="link"
                data-test="cancelButton"
            >
                {loc.t("cancel")}
            </Button>
        )}
    </div>
);

Header.displayName = "Header";
export default Header;
